import * as React from "react";
import { Icon } from "@fluentui/react/lib/Icon";

import AttributeListing from "../attribute-listing/AttributeListing";
import { TEXT } from "../../../shared/constants/texts";
import { ICON } from "../../../shared/constants/icons";
import { setSelectedAttributeData } from "../utils";

type SearchBoxProps = {
  searchRef: any;
  getAgreementData: any;
};

const SearchBox: React.FC<SearchBoxProps> = (props) => {
  const { searchRef, getAgreementData } = props;
  const [showAttributeListing, setShowAttributeListing] = React.useState(false);
  let getAgreementDataTimeout;

  const onChangeSearchAgreement = (e) => {
    e.preventDefault();
    clearTimeout(getAgreementDataTimeout);
    const searchTerm = searchRef.current.value;
    if (searchTerm.length === 0) {
      getAgreementData();
    } else {
      if (searchTerm.length >= 3) {
        getAgreementDataTimeout = setTimeout(() => {
          getAgreementData(searchTerm);
        }, 2000);
      }
    }
  };

  const onClearSearchAgreement = () => {
    const searchTerm = searchRef.current.value;
    if (searchTerm) {
      searchRef.current.value = "";
      getAgreementData();
    }
    setShowAttributeListing(false);
    setSelectedAttributeData([]);
  };

  const onEnterSearchAgreement = () => {
    const searchTerm = searchRef.current.value;
    getAgreementData(searchTerm);
  };

  const clearAttributeClicked = () => {
    setShowAttributeListing(false);
    onClearSearchAgreement();
  };

  const searchAttributeClicked = () => {
    setShowAttributeListing(false);
    onEnterSearchAgreement();
  };

  const searchText = searchRef && searchRef.current && searchRef.current.value ? searchRef.current.value : "";

  let classNameDropDownIcon = "dropdown-icon-disabled";
  if (searchText) {
    classNameDropDownIcon = "dropdown-icon";
  }

  const onPressEnterClearSearchAgreement = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onClearSearchAgreement();
    }
  };

  const onPressEnterSearchAgreement = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onEnterSearchAgreement();
    }
  };

  return (
    <div className="search-box-container-attach-from-ici">
      <div className="search-box">
        {!searchText ? (
          <div className="search-icon">
            <Icon iconName="Search" />
            <span className="sr-only">{TEXT.SEARCH}</span>
          </div>
        ) : null}
        <input
          style={{
            paddingLeft: !searchText ? "1.5rem" : "0.25rem",
            paddingRight: searchText ? "4rem" : "2rem",
          }}
          ref={searchRef}
          type="text"
          placeholder={TEXT.PLACEHOLDER_SEARCH_AGREEMENTS}
          onChange={(e) => onChangeSearchAgreement(e)}
          tabIndex={1}
        />
        {searchText ? (
          <div className="cross-search-icon">
            <div className="cross-icon" tabIndex={1} onKeyDown={onPressEnterClearSearchAgreement}>
              <Icon onClick={onClearSearchAgreement} iconName="Cancel" />
              <span className="sr-only">{TEXT.CANCEL}</span>
            </div>
            <div className="search-icon-with-cross" tabIndex={1} onKeyDown={onPressEnterSearchAgreement}>
              <Icon onClick={onEnterSearchAgreement} iconName="Search" />
              <span className="sr-only">{TEXT.SEARCH}</span>
            </div>
          </div>
        ) : null}
        <div className={classNameDropDownIcon}>
          <Icon
            iconName={!showAttributeListing ? ICON.DOWN : ICON.UP}
            onClick={searchText ? () => setShowAttributeListing(!showAttributeListing) : () => {}}
          />
          <span className="sr-only">{!showAttributeListing ? ICON.DOWN : ICON.UP}</span>
        </div>
      </div>
      {showAttributeListing ? (
        <AttributeListing clearClicked={clearAttributeClicked} searchClicked={searchAttributeClicked} />
      ) : null}
    </div>
  );
};

export default SearchBox;
